<template>
  <div class="tag-input-component form-group">
    <div class="input-tag">
      <bp-tag
        v-for="(option, index) in added"
        :key="index"
        :text="option"
        chip
        @remove="removeTag(option)"
      />
      <input
        id="input-tag"
        class="flex-fill"
        type="text"
        v-model="innerValue"
        :placeholder="placeholder"
        @blur="onSubmit"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: "Digite o texto"
    },
    placeholder: {
      type: String,
      default: "Digite o texto"
    }
  },
  data() {
    return {
      added: this.value,
      innerValue: ""
    };
  },
  watch: {
    added(newVal) {
      this.$emit("input", newVal);
    },
    value(v) {
      this.added = v;
    }
  },
  methods: {
    onSubmit() {
      const text = this.innerValue;
      const splitted = text.split(",");
      this.added = [...this.added, ...splitted.map(t => t.trim())].filter(
        a => a
      );
      this.innerValue = "";
    },
    removeTag(tag) {
      const aux = this.added.filter(t => t !== tag);
      this.added = [];
      this.added = aux;
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-input-component {
  .input-tag {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    background-color: var(--bg-1);
    border: 1px solid var(--dark-10);
    border-radius: 12px;
    padding: 16px 20px;
    transition: all 0.2s ease-in-out;

    &:hover,
    &:focus-within {
      border-color: var(--dark-20);
      background-color: var(--bg-5);
    }
    &:focus-within {
      box-shadow: 0px 0px 0px 4px rgba(0, 0, 0, 0.05);
    }

    input {
      font-size: 14px;
      height: 100%;
      min-width: 100px;
      background-color: transparent;
      border: 0;
      outline: none;
    }
  }
}
</style>
